<app-data-table
  title="Master Agent Account"
  url="masteragents"
  type="masteragent"
></app-data-table>
